import { ExportFormat } from '@mews-commander/data-access';
import { CityLedgerExportField, ExportValues } from './exportSchema';

export const defaultExportValues: ExportValues = {
    [CityLedgerExportField.format]: ExportFormat.Excel,
    [CityLedgerExportField.date]: '',
    [CityLedgerExportField.owner]: '',
    [CityLedgerExportField.ownerTypes]: [],
    [CityLedgerExportField.invoiceStatus]: [],
    [CityLedgerExportField.balanceMin]: 0,
    [CityLedgerExportField.balanceMax]: 0,
    [CityLedgerExportField.ageing]: [],
};
